<template>
  <div id="timeline">
    <div class="top_notice">
      <i class="iconfont iconlaba1"></i>
      <span class="notice_txt">截至目前{{theme}}总人数共计{{total}}人。</span>
    </div>
    <span class="Province_Trends">{{theme}}</span>

    <div class="block" :style="{height:screenHeight-73 +'px' }">
      <ul class="el-timeline is-reverse">
        <li class="el-timeline-item" v-for="(item,index) in DynamList" :key="index">
          <div class="el-timeline-item__tail"></div>
          <div
            class="el-timeline-item__node el-timeline-item__node--normal el-timeline-item__node--"
          >
            <!---->
          </div>
          <!---->
          <div class="el-timeline-item__wrapper">
            <!---->
            <div class="el-timeline-item__content" >{{item.start_time == "暂无"?item.end_time:item.start_time}}</div>
            <div class="el-timeline-item__timestamp is-bottom">{{item.batch_theme}}</div>
            <div class="el-timeline-item__timestamp is-">医护人员：{{item.num}}人</div>
            <div class="el-timeline-item__timestamp is-">出发时间：{{item.start_time}}</div>
            <div class="el-timeline-item__timestamp is-">到达时间及地点：{{item.end_time}},{{item.arrival}}</div>
            <div class="el-timeline-item__timestamp is-">战疫场所：{{item.war_site}}</div>
          </div>
        </li>

        <li class="el-timeline-item">
          <div class="el-timeline-item__tail"></div>
          <div
            class="el-timeline-item__node el-timeline-item__node--normal el-timeline-item__node--"
          >
            <!---->
          </div>
          <!---->
        </li>
      </ul>
      <div class="loading" v-show="stat"></div>
    </div>
  </div>
</template>

<script>
import wxShare from "@/mixins/wechat";
import { getDynamList } from "../api/dynamics_api";
export default {
  data() {
    return {
      screenHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      DynamList: [],
      theme: "",
      total:0,
      stat:true
    };
  },
  created() {
    const that = this;
    var id = this.$route.query.id;
    this.getDynamics(id);
  },
  mounted(){
    this.setShare()
  },
  mixins: [wxShare],
  methods: {
    setShare() {
      let root='http://'+location.host+'/';
      const shareInfo = {
        title: this.theme,
        desc: `有一种疾病比病毒更可怕，那就是“健忘”！请记住这些英雄！`,
        link: window.location.href,
        img: root + "static/images/0220.jpg"
      };
      this.wechatShare(shareInfo);
    },
    getDynamics(id) {
      let sum = 0;
      getDynamList(id).then(response => {
        this.DynamList = response.data;
        this.theme = response.data[0].theme;
        this.total = response.count.total;
        console.log(response.data)
        this.stat = false;
      });

    }
  }
};
</script>

<style scoped>
#timeline {
  width: 100%;
}
.top_notice {
  width: 100%;
  height: 35px;
  background: #f8f8f8;
  display: flex;
  align-items: center;
}
.notice_txt {
  font-size: 13px;
  color: #ee2626;
  padding-left: 16px;
}
.loading {
  margin: 1em auto 0;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  border: 2px #f8f8f8 solid;
  border-right-color: #87ceeb;
  animation: loading 1s linear infinite;
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.iconlaba1 {
  font-size: 13px;
  color: #ee2626;
  padding-left: 23px;
}
.Province_Trends {
  font-size: 16px;
  color: #67a0fb;
  margin-top: 10px;
  margin-left: 12px;
  display: inline-block;
}

.block {
  overflow-y: auto;
}
.el-timeline {
  /* margin: 0; */
  list-style: none;
  margin-left: 12px;
  margin-top: 17px;
}
.el-timeline-item {
  position: relative;
  padding-bottom: 12px;
}
.el-timeline-item__tail {
  position: absolute;
  left: 4px;
  height: 100%;
  border-left: 2px solid #f29b76;
}
.el-timeline-item__node--normal {
  left: -1px;
  width: 12px;
  height: 12px;
}
.el-timeline-item__node {
  position: absolute;
  background-color: #f29b76;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-timeline-item__wrapper {
  position: relative;
  padding-left: 20px;
  top: -3px;
}
.el-timeline-item__content {
  font-size: 16px;
  color: #777777;
}
.el-timeline-item__timestamp.is-bottom {
  margin-top: 12px;
}
.el-timeline-item__timestamp {
  font-size: 16px;
  color: #333333;
  padding-right: 20px;
}
.is- {
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/Timeline.vue